import { EAP_TYPE_OPTIONS } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { EAP_CYPHER_TYPE_OPTIONS } from '../settings-devices-eap-settings-form/components/eap-settings-form-general/eap-settings-form-general.model';
import {
    EapImportFieldDefinition,
    EapImportFieldValue,
    EapImportMappings,
    MissingCertificatesByType,
} from './settings-devices-eap-settings-importing.model';

export const EMPTY_FIELD_VALUE: EapImportFieldValue = {
    source: 'FILE',
    fileColumn: '',
    fixedValue: '',
    fixedFile: null,
    fixedFileName: '',
};

export const EMPTY_MISSING_CERTIFICATES: MissingCertificatesByType = {
    caCertificateFilenames: [],
    clientCertificateFilenames: [],
    privateKeyFilenames: [],
};

export const INITIAL_MAPPINGS: EapImportMappings = {
    name: { ...EMPTY_FIELD_VALUE },
    ssid: { ...EMPTY_FIELD_VALUE },
    eapType: { ...EMPTY_FIELD_VALUE },
    cipherType: { ...EMPTY_FIELD_VALUE },
    username: { ...EMPTY_FIELD_VALUE },
    password: { ...EMPTY_FIELD_VALUE },
    anonymousUser: { ...EMPTY_FIELD_VALUE },
    caCertificateFilename: { ...EMPTY_FIELD_VALUE },
    clientCertificateFilename: { ...EMPTY_FIELD_VALUE },
    clientPrivateKeyFilename: { ...EMPTY_FIELD_VALUE },
    clientPrivateKeyPassword: { ...EMPTY_FIELD_VALUE },
};

type TranslationFunction = (key: string, options?: Record<string, unknown>) => string;

export const getEapImportFieldDefinitions = (t: TranslationFunction): EapImportFieldDefinition[] => [
    {
        key: 'name',
        labelKey: 'settings.devices.eap-settings.eap-config-list.action.import.importing.field.name.label',
        controlType: 'text',
        required: true,
        sourceDefault: 'FILE',
        fixedSourceLabelKey: 'settings.devices.eap-settings.eap-config-list.action.import.importing.source.prefix',
        fixedPlaceholderKey:
            'settings.devices.eap-settings.eap-config-list.action.import.importing.field.name.placeholder',
    },
    {
        key: 'ssid',
        labelKey: 'settings.devices.eap-settings.eap-config-create-form.form.field.ssid',
        controlType: 'text',
        required: true,
        sourceDefault: 'FILE',
        fixedPlaceholderKey: 'settings.devices.eap-settings.eap-config-create-form.form.field.ssid.placeholder',
    },
    {
        key: 'cipherType',
        labelKey: 'settings.devices.eap-settings.eap-config-list.action.import.importing.field.cipher-type.label',
        controlType: 'select',
        required: true,
        sourceDefault: 'FILE',
        fixedPlaceholderKey:
            'settings.devices.eap-settings.eap-config-list.action.import.importing.field.cipher-type.placeholder',
        fixedOptions: EAP_CYPHER_TYPE_OPTIONS.map((option) => ({
            value: option.value,
            text: t(`settings.devices.eap-settings.eap-config-create-form.form.field.crypto-algorithm.${option.label}`),
        })),
    },
    {
        key: 'eapType',
        labelKey: 'settings.devices.eap-settings.eap-config-list.action.import.importing.field.eap-type.label',
        controlType: 'select',
        required: true,
        sourceDefault: 'FILE',
        fixedPlaceholderKey:
            'settings.devices.eap-settings.eap-config-list.action.import.importing.field.eap-type.placeholder',
        fixedOptions: EAP_TYPE_OPTIONS.map((option) => ({
            value: option.value,
            text: option.label,
        })),
    },
    {
        key: 'caCertificateFilename',
        labelKey: 'settings.devices.eap-settings.eap-config-list.action.import.importing.field.ca-certificate.label',
        controlType: 'file',
        required: true,
        sourceDefault: 'FILE',
    },
    {
        key: 'username',
        labelKey: 'settings.devices.eap-settings.eap-config-create-form.form.field.username',
        controlType: 'text',
        required: true,
        sourceDefault: 'FILE',
        fixedPlaceholderKey: 'settings.devices.eap-settings.eap-config-create-form.form.field.username.placeholder',
    },
    {
        key: 'clientCertificateFilename',
        labelKey:
            'settings.devices.eap-settings.eap-config-list.action.import.importing.field.client-certificate.label',
        controlType: 'file',
        required: true,
        sourceDefault: 'FILE',
        fixedPlaceholderKey:
            'settings.devices.eap-settings.eap-config-list.action.import.importing.field.fixed-file.placeholder',
    },
    {
        key: 'password',
        labelKey: 'settings.devices.eap-settings.eap-config-list.action.import.importing.field.password.label',
        controlType: 'text',
        required: true,
        sourceDefault: 'FILE',
        fixedPlaceholderKey: 'settings.devices.eap-settings.eap-config-create-form.form.field.password.placeholder',
        fixedInputType: 'password',
        fixedMaxLength: 255,
        fixedShowCharCount: true,
    },
    {
        key: 'clientPrivateKeyFilename',
        labelKey:
            'settings.devices.eap-settings.eap-config-list.action.import.importing.field.client-private-key.label',
        controlType: 'file',
        required: true,
        sourceDefault: 'FILE',
        fixedPlaceholderKey:
            'settings.devices.eap-settings.eap-config-list.action.import.importing.field.fixed-file.placeholder',
    },
    {
        key: 'clientPrivateKeyPassword',
        labelKey:
            'settings.devices.eap-settings.eap-config-list.action.import.importing.field.client-private-key-password.label',
        controlType: 'text',
        required: true,
        sourceDefault: 'FILE',
        fixedPlaceholderKey:
            'settings.devices.eap-settings.eap-config-list.action.import.importing.field.client-private-key-password.placeholder',
        fixedInputType: 'password',
        fixedMaxLength: 255,
        fixedShowCharCount: true,
    },
    {
        key: 'anonymousUser',
        labelKey: 'settings.devices.eap-settings.eap-config-list.action.import.importing.field.anonymous-user.label',
        controlType: 'text',
        required: true,
        sourceDefault: 'FILE',
        fixedPlaceholderKey:
            'settings.devices.eap-settings.eap-config-create-form.form.field.anonymous-user.placeholder',
        fixedMaxLength: 255,
        fixedShowCharCount: true,
    },
];
